import type { Reducer } from 'react';
import type { DealershipPickerState } from '../types';
import { FETCH_DEALERSHIPS_FAILURE, FETCH_DEALERSHIPS_REQUEST, FETCH_DEALERSHIPS_SUCCESS, RESET_DEALERSHIP } from './actions';
import { FETCH_DEALERSHIPS_FAILURE_MESSAGE, ERROR } from '../constants';
import { ApiRequestStatus } from '@makemydeal/dr-shared-types';

export type DealershipPickerReducer = Reducer<DealershipPickerState, any>;

export const dealershipPickerReducer: Reducer<DealershipPickerState, any> = (
    state: DealershipPickerState = { dealerships: [], requestStatus: ApiRequestStatus.Idle },
    action: any
) => {
    const { payload, type } = action;

    switch (type) {
        case FETCH_DEALERSHIPS_REQUEST: {
            return {
                ...state,
                requestStatus: ApiRequestStatus.Loading
            };
        }
        case FETCH_DEALERSHIPS_SUCCESS: {
            return {
                ...state,
                dealerships: payload.dealerships || [],
                requestStatus: ApiRequestStatus.Success
            };
        }
        case FETCH_DEALERSHIPS_FAILURE: {
            return {
                ...state,
                errorDetails: {
                    message: payload.message,
                    label: FETCH_DEALERSHIPS_FAILURE_MESSAGE,
                    type: ERROR
                },
                requestStatus: ApiRequestStatus.Error
            };
        }
        case RESET_DEALERSHIP: {
            return {
                ...state,
                dealerships: [],
                requestStatus: ApiRequestStatus.Idle
            };
        }
        default: {
            return state;
        }
    }
};
